export const scrollParentRect = (element: HTMLElement): { top: number; bottom: number } => {
	let node = element.parentElement;
	while (node) {
		const overflowY = getComputedStyle(node).overflowY;
		if (overflowY === 'auto' || overflowY === 'scroll') {
			const rect = node.getBoundingClientRect();
			return { top: rect.top, bottom: rect.bottom };
		}
		node = node.parentElement;
	}
	return { top: 0, bottom: window.innerHeight };
};
